<template>
    <BreadCrumb PageTitle="Create New Task" />
    <CreateNewTask />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import CreateNewTask from "../../components/Task/CreateNewTask.vue";
  
  export default defineComponent({
    name: "CreateNewTaskPage",
    components: {
      BreadCrumb,
      CreateNewTask,
    },
  });
  </script>